module.exports = __webpack_public_path__ + "img/size.1d3d68e0.svg";